<template>
    <div class="w3-container w3-center" style="width:95%">
        <div class="w3-card-2">
        <header class="w3-container w3-left-align">
            <h6><i class="fas fa-shopping-basket fa-fw w3-margin-right"></i> Basket</h6>
        </header>
        <div id="basket" class="w3-container">
            <div class="basket-item">
                <div class="basket-item-content">
                    <div class="basket-item-quantity">Quantity</div>
                    <div class="basket-item-description">Product</div>
                    <div class="basket-item-price">Price</div>
                    <div class="basket-item-buttongroup"></div>
                </div>
            </div>
            <div v-for="item in currentBasket" v-bind:key="item">
                <div class="basket-item">
                    <div class="basket-item-content">
                        <div class="basket-item-quantity">{{item.quantity}}</div>
                        <!-- <div class="basket-item-description">{{allParts[item.part_id].name}} --> 
                        <div class="basket-item-description">{{item.name}}
                            <div class="basket-item-description-details">
                                <ul style="padding : 0;list-style-type:none;">
                                    <template v-for="(value, input) in item.user_inputs" :key="input">
                                        <li  v-if="value!==''"  >
                                            {{input}} : {{value}}
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </div>
                        <div class="basket-item-price">{{item.price}}</div>
                        <div class="basket-item-buttongroup">
                            <button @click="removePartFromCart(item)">
                                x
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div style="height: 0%; width: auto; border: 1px red solid;"></div>

            <div class="basket-item" style="margin-right: 0;">
                    Total <span style="float: right;">{{totalPrice}}</span> 
            </div>

            <div class="basket-item" style="margin-left: auto; margin-right: 0;">
                <button type="button" @click="proceedWithPurchase()">
                    Proceed
                </button>
            </div>

        </div>
</div>
    </div>
</template>

<style scoped src="@/assets/styles.css">
</style>

<script>
export default {
    name: 'Basket',
    // data() {
    //     return {
    //         totalPrice: 0,
    //     }
    // },
    computed: {
        currentBasket() {
            return this.$store.getters.getBasket;
        },
        allParts() {
            return this.$store.getters.getParts;
        },
        allPackages() {
            return this.$store.getters.getPackages;
        },
        totalPrice() {
            var price = 0;
            this.currentBasket.forEach(item => {
                console.log( item.name, item.price, item.quantity )
                console.log(item)
                price += item.price;
            });
            return price;
        }
    },
    methods: {
        removePartFromCart: function(part) {
            console.log(part);
            console.log("Deleting part");
            this.$store.dispatch("removePartFromBasket", part);
        },
        proceedWithPurchase() {
            this.$router.push('/distribution/orderdetails')
        }
    },
    mounted() {
        this.$store.dispatch("initializeBasket");
    },
}
</script>